import RenderHeader from '@components/DataGrid/RenderHeader';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderCell from '@components/DataGrid/RenderCell';
import { defaultSortComparator } from '@components/DataGrid/types';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const traceInvoiceStatusDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Trc Inv Status',
	minWidth: 130,
	width: 150,
	headerName: 'Trc Inv Status',
	renderHeader: () => <RenderHeader primaryText='Trc Inv Status' />,
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				row.trcInvStatus && (
					<span
						className={styles.bold}
						title={row.trcInvStatus}
					>
						{row.trcInvStatus}
					</span>
				)
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcInvStatus } = row;
				return caseInsensitiveIncludes(value, [trcInvStatus]);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.trcInvStatus ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default traceInvoiceStatusDefinition;
